import { render, staticRenderFns } from "./RobberyComplaintNotFiledQuestion.vue?vue&type=template&id=3c6522e6&scoped=true"
import script from "./RobberyComplaintNotFiledQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyComplaintNotFiledQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyComplaintNotFiledQuestion.vue?vue&type=style&index=0&id=3c6522e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6522e6",
  null
  
)

export default component.exports